import { render, staticRenderFns } from "./activity-log-listing.vue?vue&type=template&id=2e8ff5a0&scoped=true&"
import script from "./activity-log-listing.vue?vue&type=script&lang=js&"
export * from "./activity-log-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ff5a0",
  null
  
)

export default component.exports